export default __webpack_public_path__ + "static/media/man-bar-bw.e14fbdee.jpg";